import { render, staticRenderFns } from "./m-order-confirmation-template-card.vue?vue&type=template&id=176d5bde&scoped=true&"
import script from "./m-order-confirmation-template-card.vue?vue&type=script&lang=js&"
export * from "./m-order-confirmation-template-card.vue?vue&type=script&lang=js&"
import style0 from "./m-order-confirmation-template-card.vue?vue&type=style&index=0&id=176d5bde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d5bde",
  null
  
)

export default component.exports